import script from "./InlineUppyUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./InlineUppyUploader.vue?vue&type=script&setup=true&lang=ts"

import "./InlineUppyUploader.vue?vue&type=style&index=0&id=1df77917&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df77917"]])

export default __exports__